import React, { Component } from "react";

import styled from "styled-components";

import SetArrowArticles from "./components/SetArrowArticles";
import SetCheckmarked from "./components/SetCheckmarked";
import SetColumns from "./components/SetColumns";
import SetCountingBlueBox from "./components/SetCountingBlueBox";
import SetExpansionPanels from "./components/SetExpansionPanels";
import SetHeaderHighlights from "./components/SetHeaderHighlights";
import SetHighlightBlocks from "./components/SetHighlightBlocks";
import SetHistory from "./components/SetHistory";
import SetIcons from "./components/SetIcons";
import SetImageStack from "./components/SetImageStack";
import SetLandscape from "./components/SetLandscape";
import SetOneTwoThree from "./components/SetOneTwoThree";
import SetPress from "./components/SetPress";
import SetServices from "./components/SetServices";
import SetTeam from "./components/SetTeam";
import SetThreeIcons from "./components/SetThreeIcons";

const Wrapper = styled.div`
  width: 100%;
  float: left;
`;

class SetMapper extends Component<Props, State> {
  mapper = item => {
    if (item.template && item.template.values && item.template.values.type) {
      switch (item.template.values.type.toLowerCase()) {
        case "arrowarticles":
          return <SetArrowArticles set={item.set} key={item.key} />;
        case "checkmarked":
          return <SetCheckmarked set={item.set} key={item.key} />;
        case "columns":
          return <SetColumns set={item.set} key={item.key} />;
        case "countingbluebox":
          return <SetCountingBlueBox set={item.set} key={item.key} />;
        case "expansionpanels":
          return <SetExpansionPanels set={item.set} key={item.key} />;
        case "headerhighlights":
          return <SetHeaderHighlights set={item.set} key={item.key} />;
        case "highlightblocks":
          return <SetHighlightBlocks set={item.set} key={item.key} />;
        case "history":
          return <SetHistory set={item.set} key={item.key} />;
        case "icons":
          return <SetIcons set={item.set} key={item.key} />;
        case "imagestack":
          return <SetImageStack set={item.set} key={item.key} />;
        case "landscape":
          return <SetLandscape set={item.set} key={item.key} />;
        case "onetwothree":
          return <SetOneTwoThree set={item.set} key={item.key} />;
        case "press":
        case "highlight":
          return <SetPress set={item.set} key={item.key} />;
        case "services":
          return <SetServices set={item.set} key={item.key} />;
        case "team":
          return <SetTeam set={item.set} key={item.key} />;
        case "threeicons":
          return <SetThreeIcons set={item.set} key={item.key} />;
        default:
      }
    }
  };

  render() {
    return (
      <Wrapper>
        {this.props.content ? this.mapper(this.props.content) : ""}
      </Wrapper>
    );
  }
}

export default SetMapper;



// WEBPACK FOOTER //
// ./src/SetMapper.js